import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TenantConfigViewData } from 'src/dao/tenantConfigClient';
import { ErrorBoundaryComponentError } from 'src/components/ErrorBoundary/ErrorBoundary.slice';

export interface FooterConfig {
  footerType: string;
  configApi: {
    url: string;
    params: { appName: string };
  };
  dataApi: {
    url: string;
  };
}

export interface FooterSlice {
  config: FooterConfig | null;
  viewDefn: TenantConfigViewData | null;
  tenantConfigLoading: boolean;
  error: ErrorBoundaryComponentError | null;
}

const initialState: FooterSlice = {
  config: null,
  viewDefn: null,
  tenantConfigLoading: false,
  error: null,
};

const footerSlice = createSlice({
  name: 'Footer',
  initialState,
  reducers: {
    requestTenantConfig(state) {
      state.tenantConfigLoading = true;
      state.error = null;
    },
    receiveTenantConfig(state, action: PayloadAction<TenantConfigViewData>) {
      state.tenantConfigLoading = false;
      state.viewDefn = action.payload;
    },
    setFooterConfig(state, action: PayloadAction<FooterConfig>) {
      state.config = action.payload;
    },
    receiveError(state, action: PayloadAction<ErrorBoundaryComponentError>) {
      state.tenantConfigLoading = false;
      state.error = action.payload;
    },
    cleanUp() {
      return initialState;
    },
  },
});

export const { requestTenantConfig, receiveTenantConfig, setFooterConfig, receiveError, cleanUp } = footerSlice.actions;

export default footerSlice.reducer;
